import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const pontioTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.pontio,
  logoUrl: "https://cdn.nemuru.com/assets/logos/pontio-logo.svg",
  palette: {
    secondary: {
      main: "#265665",
      contrastText: "#FDFDFD",
    },
    primary: {
      main: "#6B9CA7",
      contrastText: "#FDFDFD",
    },
    text: {
      title: "#1F4450",
      primary: "#252121",
      secondary: "#7F7C7C",
    },
    error: {
      light: "#f59090",
      main: "#E73939",
      dark: "#d30a0a",
      contrastText: "#252121",
    },
    warning: {
      light: "#efd176",
      main: "#F2B705",
      dark: "#d99e04",
      contrastText: "#252121",
    },
    info: {
      light: "#b3dbe1",
      main: "#177D8C",
      dark: "#0e5b66",
      contrastText: "#FDFDFD",
    },
    success: {
      light: "#90d9c0",
      main: "#478670",
      dark: "#397560",
      contrastText: "#FDFDFD",
    },
    // additional colors
    dark: {
      main: "#252121",
      accent: "#1F4450",
      contrastText: "#FDFDFD",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#90d9c0",
      approved: "#478670",
      analysing: "#177D8C",
      sent: "#1F4450",
      cancelled: "#F9F6F6",
      denied: "#E73939",
    },
    grey: {
      50: "#F9F9F9",
      100: "#f6f6f6",
      200: "#F0F0F0",
      300: "#E9E9E9",
      400: "#E0E0E0",
      500: "#CECACA",
      600: "#B2ACAC",
      700: "#A2A2A2",
      800: "#7F7C7C",
      900: "#262626",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#FDFDFD",
  typography: {
    fontFamily: "Urbanist, Helvetica, Arial, sans-serif",
  },
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
};
